import Icon from "../../../components/element/icon";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import Row from "../../../components/element/row";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import Button from "../../../components/element/button";
import useRequireAuth from "../../../components/hook/use.require.auth";

export default function ProfileOverview({ setActiveTab }) {
  const { isDesktop } = useWindowDimension();
  const { profileInfo } = useSelector((state) => state.profile);
  const tileCounts = profileInfo?.tile_counts || {};
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { requireAuth } = useRequireAuth();

  const journeyList = [
    {
      type: "purchases",
      list: [
        {
          icon: "solar:dollar-minimalistic-linear",
          key: "my_reserve",
          title: "My Reserve",
          subtitle: "Reserved car status",
          status: "",
        },
        {
          icon: "hugeicons:bank",
          key: "financing",
          title: "Financing",
          subtitle: "Loan or cash purchase progress",
          status: "financing",
        },
        {
          icon: "solar:shield-up-linear",
          key: "insurance",
          title: "Insurance",
          subtitle: "Request insurance quotation",
          status: "insurance",
        },
        {
          icon: "hugeicons:credit-card-pos",
          key: "final_payment",
          title: "Final Payment", //Complete
          subtitle: "Track transfer and delivery progress",
          status: "delivery",
        },
      ],
    },
    {
      type: "consignments",
      list: [
        {
          icon: "hugeicons:apple-reminder",
          key: "my_listing",
          title: "My Listing",
          subtitle: "View listed cars",
        },
        {
          icon: "hugeicons:ai-search-02",
          key: "inspection",
          title: "Inspection",
          subtitle: "View inspection status",
          status: "inspection",
        },
        {
          icon: "hugeicons:sale-tag-02",
          key: "live",
          title: "Live",
          subtitle: "Live selling status",
          status: "live",
        },
        {
          icon: "ri:auction-line",
          key: "sold",
          title: "Sold",
          subtitle: "Completed history",
          status: "sold",
        },
      ],
    },
  ];

  return (
    <Container className="profile-overview">
      <Row className="_row profile-dashboard">
        {journeyList.map((journey) => (
          <Col className="_col journey-card" key={journey?.type}>
            <h3 className="_label journey-title">
              <span>{t("My")}</span> {t(journey.type)}
            </h3>
            <p className="_label journey-subtitle">

              {t(
                `Track your ${journey?.type === "purchases" ? "buying" : "selling"} journey`,
              )}

            </p>
            <Col className="_col journey-action-list">
              {journey.list.map((action) => (
                <Button
                  type="button"
                  className="_button journey-action-item"
                  key={action.title}
                  onClick={() => {
                    const path = `/${journey.type}${
                      action.status ? `?stage=${action.status}` : ""
                    }`;

                    requireAuth(() => navigate(path), { path });
                  }}
                >
                  <Icon
                    icon={action.icon}
                    className="_svg dashboard-icon"
                    gradient
                    gradientStops={[
                      { offset: "0.2", color: "#DDB66E" },
                      { offset: "0.95", color: "#A8752E" },
                    ]}
                    width={isDesktop ? 32 : 27}
                    height={isDesktop ? 32 : 27}
                  />
                  <span className="_label action-copy">
                    <span className={`_label action-title`}>
                      {/* ${
                    item.summaryTitle ? "has-summary" : ""
                  } */}

                      {t(action.title)}

                      {/* {item.summaryTitle && (
                      <span className="summary-title">
                        {t(item.summaryTitle)}
                      </span>
                    )} */}
                    </span>
                    <span className="_label action-subtitle">
                      {t(action.subtitle)}
                    </span>
                  </span>
                  {Number(tileCounts?.[action.key]) > 0 && (
                    <span className="_label action-count">
                      {tileCounts[action.key]}
                    </span>
                  )}
                </Button>
              ))}
            </Col>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
